import Login from '../Components/admin/Login';
import Home from '../Components/admin/Home';
import BIM from '../Components/admin/BIM';
import Partners from '../Components/admin/Partners';
import Portfolio from '../Components/admin/Portfolio';
import Portfolio2 from '../Components/admin/Portfolio2';

export const menu = [
    {
        id: 'services',
        url: '/admin/home',
        text: 'Մեր ծառայությունները',
    },
    {
        id: 'bim',
        url: '/admin/bim',
        text: 'Ինչ է BIM-ը',
    },
    {
        id: 'portfolio',
        url: '/admin/portfolio',
        text: 'Պորտֆոլիո',
    },
    {
        id: 'portfolio2',
        url: '/admin/portfolio2',
        text: 'Պորտֆոլիո 2',
    },
    {
        id: 'partners',
        url: '/admin/partners',
        text: 'Մեր Գործընկերները',
    },
];

export const language = [
    {
        lang: 'en',
        title: 'Title',
        titleMore: 'Title (English)',
        name: 'Name',
        nameMore: 'Name (English)',
        description: 'Description',
        descMore: 'Description (English)',
        price: 'Price',
        priceMore: 'Price (English)',
        feedback: 'Feedback',
        feedbackMore: 'Feedback (English)',
        feedback2: 'Second Feedback',
        feedback2More: 'Second Feedback (English)',
    },
    {
        lang: 'ru',
        name: 'Имя',
        title: 'Загаловок',
        titleMore: 'Заголовок (Русский)',
        nameMore: 'Имя (Русский)',
        description: 'Описания',
        descMore: 'Описания (Русский)',
        price: 'Стоимость',
        priceMore: 'Стоимость (Русский)',
        feedback: 'Отзыв',
        feedbackMore: 'Отзыв (Русский)',
        feedback2: 'Второй отзыв',
        feedback2More: 'Второй отзыв (Русский)',
    },
    {
        lang: 'arm',
        name: 'Անուն',
        title: 'Վերնագիր',
        nameMore: 'Անուն (Հայերեն)',
        titleMore: 'Վերնագիր (Հայերեն)',
        description: 'Նկարագրություն',
        descMore: 'Նկարագրություն (Հայերեն)',
        price: 'Արժեք',
        priceMore: 'Արժեք (Հայերեն)',
        feedback: 'Արձագանք',
        feedbackMore: 'Արձագանք (Հայերեն)',
        feedback2: 'Երկրորդ արձագանքը',
        feedback2More: 'Երկրորդ արձագանքը (Հայերեն)',
    }
];

export const langs = ['en', 'ru', 'arm'];

export const swalText = {
    del: 'Վստահ ե՞ք, որ ուզում եք ջնջել',
    change: 'Վստահ ե՞ք, որ ուզում եք փոխել',
    delMore: 'Ջնջվածը վերադարձնել չի լինի',
    yes: 'Այո',
    cancel: 'Ոչ',
    titleSuccess: 'Հաջողությամբ ավելացվեց',
    ok: 'Լավ',
};

export const infoText = ['enTitle', 'enDescription', 'ruTitle', 'ruDescription', 'armTitle', 'armDescription'];

export const adminRouts = [
    {
        path: '/admin',
        component: Login,
        exact: true,
    },
    {
        path: '/admin/home',
        component: Home,
        exact: false,
    },
    {
        path: '/admin/bim',
        component: BIM,
        exact: false,
    },
    {
        path: '/admin/portfolio',
        component: Portfolio,
        exact: false,
    },
    {
        path: '/admin/portfolio2',
        component: Portfolio2,
        exact: false,
    },
    {
        path: '/admin/partners',
        component: Partners,
        exact: false,
    },
];

export const bimPageText = [
    {
        lang: 'en',
        add: 'Add',
        language: 'En',
        link: 'Add link',
        quality: 'quality',
        select: 'Select quality',
    },
    {
        lang: 'ru',
        language: 'Ру',
        add: 'Добавить',
        quality: 'Качество',
        link: 'Добавить ссылку',
        select: 'Выберите качество',
    },
    {
        lang: 'arm',
        language: 'Հայ',
        quality: 'Որակ',
        add: 'Ավելացնել',
        link: 'Ավելացրեք հղում',
        select: 'Ընտրեք որակը',
    }
];

export const qualities = [
    'hq',
    'default',
    'medium',
    'standard',
    'maxRes',
];
